module.exports = __webpack_public_path__ + "static/mtb-13-792a24d47651e9daa92cdc36c87b3ac0.jpg";